import CreditCapabilities from './CreditCapabilities.js';

const instance = new CreditCapabilities();

export default instance;
